// extracted by mini-css-extract-plugin
module.exports = {"fixSize":"styles-module__fixSize___PesyS","cardError":"styles-module__cardError___RN2HX"};